/**
 * Format call duration in human-readable format
 * @param seconds Duration in seconds
 * @returns Formatted string like "4 min 32 sec", "1 min", "45 sec"
 */
export function formatDuration(seconds: number): string {
  if (seconds <= 0) return '0 sec'

  const min = Math.floor(seconds / 60)
  const sec = seconds % 60

  if (min === 0) {
    return `${sec} sec`
  }

  if (sec === 0) {
    return `${min} min`
  }

  return `${min} min ${sec} sec`
}
